import React from 'react';
import { Intl } from '@erecruit/core';
import {
  Button,
  Form,
  FormItem,
  H1,
  Modal,
  ModalProps,
  Option,
  Select,
  TextArea,
} from '@erecruit/ui-kit';
import { Resources } from '@erecruit/types';
import { ButtonContainer } from '@erecruit/modules';

const { FormattedMessage, injectIntl } = Intl;

const ApproveModalTitle = (
  <H1>
    <FormattedMessage id={messageIds.vms.approvalPath.approveConfirm} />
  </H1>
);

const ApprovePageTitle = (
  <H1 color="headerTertiary">
    <FormattedMessage id={messageIds.vms.approvalPath.approve} />
  </H1>
);

const RejectModalTitle = (
  <H1>
    <FormattedMessage id={messageIds.vms.approvalPath.reject} />
  </H1>
);

const RejectPageTitle = (
  <H1 color="headerTertiary">
    <FormattedMessage id={messageIds.vms.approvalPath.rejectConfirm} />
  </H1>
);

export interface ApproveRejectModalForm {
  rejectionReasonId?: number;
  note: string;
}

export interface ApproveRejectModalProps
  extends Intl.InjectedIntlProps,
    ModalProps {
  onSubmit(values: ApproveRejectModalForm): void;
  rejectionReasons?: Resources.ApprovalRejectionReason[];
  type: 'Approve' | 'Reject';
}

const ApproveRejectModal = ({
  intl,
  onSubmit,
  rejectionReasons,
  type,
  ...modalProps
}: ApproveRejectModalProps) => {
  return (
    <Modal
      {...modalProps}
      footer={false}
      width="642px"
      destroyOnClose
      pageTitle={type === 'Approve' ? ApprovePageTitle : RejectPageTitle}
    >
      {type === 'Approve' ? ApproveModalTitle : RejectModalTitle}
      <Form
        onValidFieldsSubmit={values =>
          onSubmit(values as ApproveRejectModalForm)
        }
      >
        {type === 'Reject' && rejectionReasons && (
          <FormItem
            id={nameof<ApproveRejectModalForm>(o => o.rejectionReasonId)}
            label={intl.formatMessage({
              id: messageIds.vms.approvalPath.rejectionReason,
            })}
            options={{
              rules: [{ required: true }],
            }}
          >
            <Select
              placeholder={intl.formatMessage({
                id: messageIds.vms.approvalPath.rejectionReason,
              })}
            >
              {rejectionReasons?.map(
                ({ id, name }: Resources.ApprovalRejectionReason) => (
                  <Option key={id} value={id}>
                    {name}
                  </Option>
                ),
              )}
            </Select>
          </FormItem>
        )}
        <FormItem
          id={nameof<ApproveRejectModalForm>(o => o.note)}
          label={intl.formatMessage({
            id: messageIds.vms.approvalPath.note,
          })}
          options={{ rules: [{ required: true }] }}
        >
          <TextArea autoSize={{ minRows: 4 }} />
        </FormItem>
        <ButtonContainer>
          <Button size="large" onClick={modalProps.onCancel}>
            <FormattedMessage id={messageIds.vms.approvalPath.cancel} />
          </Button>
          <Button htmlType="submit" size="large" key="confirm" type="primary">
            <FormattedMessage id={messageIds.vms.approvalPath.yes} />
          </Button>
        </ButtonContainer>
      </Form>
    </Modal>
  );
};

export default injectIntl(ApproveRejectModal);
